import resizeImageWithDataUrl from "utils/resizeImageWithDataUrl"

const resizeImagesAndEncodeToTag = (message_rich: string): Promise<string> => {
  const regex = /<img height="(\d+)" width="(\d+)" src="(data:image\/[^;]+;base64,[^"]+)" \/>/g
  let result = message_rich

  const matches: Array<{
    match: string
    height: number
    width: number
    src: string
  }> = []

  let match
  while ((match = regex.exec(message_rich)) !== null) {
    matches.push({
      match: match[0],
      height: parseInt(match[1], 10),
      width: parseInt(match[2], 10),
      src: match[3],
    })
  }

  if (matches.length === 0) {
    return Promise.resolve(message_rich)
  }

  return Promise.all(
    matches.map(({ match, height, width, src }) => {
      return new Promise<string>(resolve => {
        resizeImageWithDataUrl({
          dataUrl: src,
          width,
          height,
        })
          .then(resizedBase64 => {
            resolve(`<${resizedBase64}data:image/png;>`)
          })
          .catch(() => {
            resolve(match)
          })
      })
    }),
  ).then(replacements => {
    matches.forEach((matchData, index) => {
      result = result.replace(matchData.match, replacements[index])
    })

    return result
  })
}

export default resizeImagesAndEncodeToTag
